import { useEffect, useRef } from 'react';

const TIMEOUT_MS = 15 * 60 * 1000;
const CHECK_INTERVAL_MS = 60 * 1000;

export function useSessionTimeout(onTimeout: () => void, active: boolean) {
  const lastActivityRef = useRef(Date.now());
  const onTimeoutRef = useRef(onTimeout);
  onTimeoutRef.current = onTimeout;

  useEffect(() => {
    if (!active) return;

    const resetTimer = () => { lastActivityRef.current = Date.now(); };

    const check = () => {
      if (Date.now() - lastActivityRef.current >= TIMEOUT_MS) {
        onTimeoutRef.current();
      }
    };

    const onVisibilityChange = () => {
      if (document.visibilityState === 'visible') check();
    };

    document.addEventListener('click', resetTimer, { passive: true });
    document.addEventListener('touchstart', resetTimer, { passive: true });
    document.addEventListener('keydown', resetTimer, { passive: true });
    document.addEventListener('visibilitychange', onVisibilityChange);
    const id = setInterval(check, CHECK_INTERVAL_MS);

    return () => {
      document.removeEventListener('click', resetTimer);
      document.removeEventListener('touchstart', resetTimer);
      document.removeEventListener('keydown', resetTimer);
      document.removeEventListener('visibilitychange', onVisibilityChange);
      clearInterval(id);
    };
  }, [active]);
}
